export var SearchError;
(function (SearchError) {
})(SearchError || (SearchError = {}));
var SearchRequest = /** @class */ (function () {
    function SearchRequest(query) {
        this.knownErrorCodes = Object.values(SearchError);
        this.path = "search?text=".concat(query, "&perPage=8");
    }
    return SearchRequest;
}());
export { SearchRequest };
